import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import ContentPage from '../../components/ContentPage/ContentPage';
import s from './Page.css';

class Page extends React.Component {
    static propTypes = {
        data: PropTypes.any
    }

    render() {
        const { data } = this.props;
        let title = data && data.metaTitle;
        return (
            <ContentPage title={title} data={data} />
        )
    }
}

export default withStyles(s)(Page);